import React, { useEffect, useState } from "react";
import * as Func from "helpers/functions";
import * as HMS from "containers/backend/common/component/Index";
import Wrapper from "containers/backend/common/component/Wrapper";
import AntSelect, {
  AntOption,
} from "containers/backend/common/component/AntSelect";
import { Button, Col, Icon, Modal, Row } from "antd";
import Input from "containers/backend/common/component/Input";
import DEFINE, { DATE_TIME_FORMAT } from "constants/Define";
import moment from "moment";
import { getMomentDate } from "utils/commonUtils";
import { withTranslation } from "react-i18next";
import {useGetDetailFlightTracking} from 'hooks/flightTracking/useGetDetailFlightTracking'
import Text from "antd/lib/typography/Text";
import './PopupFlight.less'

const PopupFlight = (props) => {
  //! Props
  const {
    handleClosePopupFlight,
    t,
    airportDeparture,
    selectFilterSearch,
    airportArrival,
    airlineDomestic,
    tour,
    order,
    permissionsOrder,
    permissionsFlightTracking,
    flightTrackingOrderItem
  } = props;
  //! State
  const {data: flightTrackingDetail, error, isLoading, refresh} = useGetDetailFlightTracking(flightTrackingOrderItem?.id)
  const [flightData, setFlightData] = useState({
    itemVariantId: flightTrackingDetail?.itemVariantId ?? tour.itemVariantId ?? "",
    orderId: flightTrackingDetail?.orderId ?? order.id ?? "",
    orderCode: flightTrackingDetail?.orderCode ?? order.orderCode ?? "",
    departureAirportCode: flightTrackingDetail?.departureAirportCode ?? undefined,
    arrivalAirportCode: flightTrackingDetail?.arrivalAirportCode ?? undefined,
    airlineCode: flightTrackingDetail?.airlineCode ?? undefined,
    airlineNumber: flightTrackingDetail?.airlineNumber ?? "",
    departureDate: "",
    departureTime: "",
  });
  const [validation, setValidation] = useState({});

  //! Function
  const handleChange = (fieldName, value) => {
    if(value.length >10 && fieldName === 'airlineNumber'){
      return
    }
    setFlightData({
      ...flightData,
      [fieldName]: value,
    });
  };
  const handleSubmitFlight = () => {
    if(validate()){
      if(flightTrackingOrderItem){
        props.updateFlightTracking({...flightData, id: flightTrackingOrderItem?.id});
        handleClosePopupFlight && handleClosePopupFlight();
      }else{
        props.createFlightTracking(flightData);
        handleClosePopupFlight && handleClosePopupFlight();
      }
    }
  };

  const removeFlightTracking = () => {
    props.deleteFlightTracking && props.deleteFlightTracking(flightTrackingOrderItem );
    setTimeout(handleClosePopupFlight, 300);

  }
  const onRemove = () => {
      const { confirm } = Modal;
      confirm({
          title: Func.formatValidation(t('validation.statusCode.code.7'), t(`item.order.flightInfo`)),
          content: flightTrackingOrderItem?.airlineNumber,
          okText: t(`action.remove`),
          cancelText: t(`action.cancel`),
          onOk: removeFlightTracking,
      });
  };

  //! Validate
  const validate = () => {
    const validate = {
      required: {
        departureAirportCode: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.order.airportDeparture`)),
        arrivalAirportCode: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.order.airportArrival`)),
        airlineCode: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.order.airportDomestic`)),
        airlineNumber: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.order.flight`)),
        departureDate: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.order.departureDate`)),
        departureTime: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.order.departureTime`)),
      }
    }
    let valueValidate = {};
    let result = Func.multipleValidate({ ...flightData }, validate, valueValidate);
    setValidation(result);
    return Object.keys(result).length < 1;
  };

  //! Effect
  useEffect(() => {
    if(flightTrackingOrderItem?.id) {
      const newFlightData = flightData;
      newFlightData.itemVariantId = flightTrackingDetail?.itemVariantId ?? "";
      newFlightData.orderId = flightTrackingDetail?.orderId ?? "";
      newFlightData.orderCode = flightTrackingDetail?.orderCode ?? "";
      newFlightData.departureAirportCode = flightTrackingDetail?.departureAirportCode ?? undefined;
      newFlightData.arrivalAirportCode = flightTrackingDetail?.arrivalAirportCode ?? undefined;
      newFlightData.airlineCode = flightTrackingDetail?.airlineCode ?? undefined;
      newFlightData.airlineNumber = flightTrackingDetail?.airlineNumber ?? "";
      newFlightData.departureDate = moment(flightTrackingDetail?.departureTime).format('YYYY-MM-DD') ?? "";
      newFlightData.departureTime = moment(flightTrackingDetail?.departureTime).format('HH:mm') ?? "";
      setFlightData(newFlightData);
    }
  },[flightTrackingDetail])
  //! Render
  return (
    <HMS.PopupModelComponent
      title={t("item.order.flightInfoTitle")}
      visible={true}
      centered={true}
      onClose={handleClosePopupFlight}
      confirmLoading={false}
      onSubmit={handleSubmitFlight}
      width={1000}
      footer={[
        <Row key="submit" type='flex' justify="space-between">
          <Col>
            <Button type="link" disabled={!flightTrackingOrderItem || !permissionsFlightTracking?.allowDelete} onClick={onRemove}>
              <Text className="delete-text">Huỷ cấu hình</Text>
            </Button>
          </Col>
          <Col>
            {
              flightTrackingOrderItem ? 
              <Button disabled={!permissionsFlightTracking?.allowUpdate && !permissionsOrder?.allowUpdate} type='primary' onClick={handleSubmitFlight}>Cập nhật</Button>
              :
              <Button disabled={!permissionsFlightTracking?.allowCreate && !permissionsOrder?.allowUpdate} type='primary' onClick={handleSubmitFlight}>Lưu lại</Button>
            }
          </Col>
        </Row>
      ]}
    >
      <Wrapper className="col-md-12 row m-0 p-0">
        <Wrapper className="col-md-6">
          <HMS.FormWrapperInputComponent
            labelTitle={t("item.order.airportDeparture")}
            isRequired={true}
            isValidation={true}
            validation={validation.departureAirportCode}
            messageBelowInput={true}
            // typeInput={true}
          >
            <AntSelect
              className="select-types"
              showArrow
              showSearch
              suffixIcon={<Icon type="search" />}
              // mode="multiple"
              placeholder={Func.capitalizeFirstLetter(
                (
                  t("placeHolderForm.select") +
                  " " +
                  t("item.order.airportDeparture")
                ).toLowerCase()
              )}
              value={flightData.departureAirportCode}
              onChange={(code) => handleChange("departureAirportCode", code)}
              filterOption={selectFilterSearch}
              style={{ width: "100%" }}
            >
              {(airportDeparture || []).map((item) => (
                <AntOption key={item.id} value={item.id}>
                  {item.id}-{item.name}
                </AntOption>
              ))}
            </AntSelect>
          </HMS.FormWrapperInputComponent>
        </Wrapper>
        <Wrapper className="col-md-6">
          <HMS.FormWrapperInputComponent
            labelTitle={t("item.order.airportArrival")}
            isRequired={true}
            isValidation={true}
            validation={validation.arrivalAirportCode}
            messageBelowInput={true}
            // typeInput={true}
          >
            <AntSelect
              className="select-types"
              showArrow
              showSearch
              suffixIcon={<Icon type="search" />}
              // mode="multiple"
              placeholder={Func.capitalizeFirstLetter(
                (
                  t("placeHolderForm.select") +
                  " " +
                  t("item.order.airportArrival")
                ).toLowerCase()
              )}
              filterOption={selectFilterSearch}
              value={flightData.arrivalAirportCode}
              onChange={(code) => handleChange("arrivalAirportCode", code)}
              style={{ width: "100%" }}
            >
              {(airportArrival || []).map((item) => (
                <AntOption key={item.id} value={item.id}>
                  {item.id}-{item.name}
                </AntOption>
              ))}
            </AntSelect>
          </HMS.FormWrapperInputComponent>
        </Wrapper>
        <Wrapper className="col-md-6">
          <HMS.FormWrapperInputComponent
            labelTitle={t("item.order.airportDomestic")}
            isRequired={true}
            isValidation={true}
            validation={validation.airlineCode}
            messageBelowInput={true}
            // typeInput={true}
          >
            <AntSelect
              className="select-types"
              showArrow
              showSearch
              suffixIcon={<Icon type="search" />}
              filterOption={selectFilterSearch}
              // mode="multiple"
              placeholder={Func.capitalizeFirstLetter(
                (
                  t("placeHolderForm.select") +
                  " " +
                  t("item.order.airportDomestic")
                ).toLowerCase()
              )}
              value={flightData.airlineCode}
              onChange={(code) => handleChange("airlineCode", code)}
              style={{ width: "100%" }}
            >
              {(airlineDomestic || []).map((item) => (
                <AntOption key={item.id} value={item.id}>
                  {item.id}-{item.name}
                </AntOption>
              ))}
            </AntSelect>
          </HMS.FormWrapperInputComponent>
        </Wrapper>
        <Wrapper className="col-md-6">
          <HMS.FormWrapperInputComponent
            labelTitle={t("item.order.flight")}
            isRequired={true}
            isValidation={true}
            validation={validation.airlineNumber}
            messageBelowInput={true}
          >
            <Input
              type="text"
              autoComplete="off"
              placeholder={Func.capitalizeFirstLetter(
                (
                  t("placeHolderForm.input") +
                  " " +
                  t("item.order.flight")
                ).toLowerCase()
              )}
              className="form-control"
              name="airlineNumber"
              value={flightData.airlineNumber}
              onChange={(e) => handleChange("airlineNumber", e.target.value)}
            />
          </HMS.FormWrapperInputComponent>
        </Wrapper>
        <Wrapper className="col-md-6">
          <HMS.FormWrapperInputComponent
            labelTitle={t(`item.order.departureDate`)}
            isRequired={true}
            isValidation={true}
            validation={validation.departureDate}
            messageBelowInput={true}
          >
            <HMS.DatePickerComponent
              disabledDate={(current) =>
                current && current < moment().add(-1, "day")
              }
              onChange={(data) => handleChange("departureDate", data.value)}
              name={"departureDate"}
              format={DATE_TIME_FORMAT.SHORT_DATE_EXPORT}
              value={getMomentDate(flightData.departureDate) || null}
              placeholder={Func.capitalizeFirstLetter(
                (
                  t("placeHolderForm.select") +
                  " " +
                  t("item.order.departureDate")
                ).toLowerCase()
              )}
              style={{ width: "100%" }}
            />
          </HMS.FormWrapperInputComponent>
        </Wrapper>
        <Wrapper className="col-md-6">
          <HMS.FormWrapperInputComponent
            labelTitle={t("item.order.departureTime")}
            isRequired={true}
            isValidation={true}
            validation={validation.departureTime}
            messageBelowInput={true}
          >
            <Input
              type="time"
              autoComplete="off"
              placeholder={Func.capitalizeFirstLetter(
                (
                  t("placeHolderForm.input") +
                  " " +
                  t("item.order.departureTime")
                ).toLowerCase()
              )}
              className="form-control"
              name="departureTime"
              value={flightData.departureTime}
              onChange={(e) => handleChange("departureTime", e.target.value)}
            />
          </HMS.FormWrapperInputComponent>
        </Wrapper>
      </Wrapper>
    </HMS.PopupModelComponent>
  );
};

export default withTranslation()(PopupFlight);
